import Service from '../Service'
import {http} from '../config'

export default class ParametroService extends Service{

    constructor(){
        super('parametro');
    }

    EnviarCertificadoDigital(arquivo, senha){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', arquivo, arquivo.name);

        return http.post(`${this.getNomeControle()}/certificadodigital`, bodyFormData, {
            params: {
                senha
            }
        });
    }

}